import { HiddenA11yText } from 'app/components/ExternalLink/ExternalLink.styles';
import { Survey } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import {
    CloseButton,
    FixedContainer,
    StyledFeedbackLink,
    StyledSurvey,
    StyledThankYou,
    StyledThankYouImage,
    ThankYouHeading,
    ThankYouTextContainer,
} from './StyledSurvey.styles';

type Props = {
    survey: Survey;
    onCloseSurvey: (id: string) => void;
    heading: string;
    usabilitySurveyLink: string;
};

const ThankYou = ({ survey, onCloseSurvey, heading, usabilitySurveyLink = null }: Props): JSX.Element => (
    <FixedContainer>
        <StyledThankYou>
            <StyledThankYouImage />
            <StyledSurvey>
                <ThankYouTextContainer>
                    <ThankYouHeading>{heading}</ThankYouHeading>
                    {usabilitySurveyLink && (
                        <StyledFeedbackLink href={usabilitySurveyLink}>
                            Lämna gärna feedback på testet här
                        </StyledFeedbackLink>
                    )}
                </ThankYouTextContainer>
                <CloseButton
                    type="button"
                    onClick={() => {
                        onCloseSurvey(survey.id);
                    }}
                >
                    <HiddenA11yText>Stäng enkät</HiddenA11yText>
                </CloseButton>
            </StyledSurvey>
        </StyledThankYou>
    </FixedContainer>
);

export default ThankYou;
